import { SvgIcon } from '@mui/material';
import {  observer } from 'mobx-react';
import React from 'react';
import { IPropsSvgIcone } from '../../modelo/Icone';


class IconeEspelhoProcesso extends React.Component<IPropsSvgIcone> {

    render() {
        const { size, style, ...props } = this.props;
        return (
            <SvgIcon {...props} style={{ ...style, ...(size ? { fontSize: size } : {}) }}>
                <svg height="24" viewBox="0 0 40 40" width="24" role='presentation'>
                    <path style={{ fill: this.props.htmlColor || 'currentColor' }}
                        d="M 20.96,6.04
           C 20.96,6.04 6.01,6.01 6.01,6.01
             6.01,6.01 5.97,6.98 5.97,6.98
             5.97,6.98 5.01,6.98 5.01,6.98
             5.01,6.98 4.98,7.98 4.98,7.98
             4.98,7.98 4.01,8.00 4.01,8.00
             4.01,8.00 3.99,32.00 3.99,32.00
             3.99,32.00 4.98,32.00 4.98,32.00
             4.98,32.00 5.01,32.99 5.01,32.99
             5.01,32.99 6.02,33.00 6.02,33.00
             6.02,33.00 6.00,34.01 6.00,34.01
             6.00,34.01 30.00,34.01 30.00,34.01
             30.00,34.01 30.01,32.99 30.01,32.99
             30.01,32.99 31.02,33.00 31.02,33.00
             31.02,33.00 30.98,32.00 31.00,32.00
             31.02,32.00 32.02,32.00 32.02,32.00
             32.02,32.00 32.00,19.00 32.00,19.00
             32.00,19.00 31.00,19.00 31.00,19.00
             31.00,19.00 31.00,20.00 31.00,20.00
             31.00,20.00 30.02,20.00 30.02,20.00
             30.02,20.00 30.00,22.02 30.00,22.02
             30.00,22.02 29.01,22.00 29.01,22.00
             29.01,22.00 28.99,22.99 28.99,22.99
             28.99,22.99 28.00,22.98 28.00,22.98
             28.00,22.98 28.00,29.99 28.00,29.99
             28.00,29.99 8.01,30.00 8.01,30.00
             8.01,30.00 8.00,13.02 8.00,13.02
             8.00,13.02 14.01,13.00 14.01,13.00
             14.01,13.00 14.01,12.00 14.01,12.00
             14.01,12.00 15.02,11.96 15.02,11.96
             15.02,11.96 15.02,10.96 15.02,10.96
             15.02,10.96 16.02,11.02 16.02,11.02
             16.02,11.02 16.02,10.00 16.02,10.00
             16.02,10.00 17.01,9.99 17.01,9.99
             17.01,9.99 17.02,9.00 17.02,9.00
             17.02,9.00 19.02,9.00 19.02,9.00
             19.02,9.00 19.02,7.99 19.02,7.99
             19.02,7.99 20.01,8.00 20.01,8.00
             20.01,8.00 20.01,7.01 20.01,7.01
             20.01,7.01 20.99,7.00 20.99,7.00
             20.99,7.00 20.98,6.04 20.98,6.04M 19.01,9.99
           C 19.01,9.99 19.01,10.97 19.01,10.97
             19.01,10.97 18.01,10.99 18.01,10.99
             18.01,10.99 18.01,11.99 18.01,11.99
             18.01,11.99 17.00,12.00 17.00,12.00
             17.00,12.00 17.01,14.00 17.01,14.00
             17.01,14.00 17.98,14.07 17.98,14.07
             17.98,14.07 17.98,14.98 17.98,14.98
             17.98,14.98 18.98,15.04 18.98,15.04
             18.98,15.04 19.01,15.99 19.01,15.99
             19.01,15.99 22.01,16.01 22.01,16.01
             22.01,16.01 22.00,15.00 22.00,15.00
             22.00,15.00 23.98,15.02 23.98,15.02
             23.98,15.02 23.98,16.97 23.98,16.97
             23.98,16.97 23.01,17.01 23.01,17.01
             23.01,17.01 23.01,19.98 23.01,19.98
             23.01,19.98 23.97,20.02 23.97,20.02
             23.97,20.02 24.01,21.00 24.01,21.00
             24.01,21.00 24.99,21.00 24.99,21.00
             24.99,21.00 25.00,22.00 25.00,22.00
             25.00,22.00 27.00,22.01 27.00,22.01
             27.00,22.01 27.00,21.01 27.00,21.01
             27.00,21.01 28.00,20.99 28.00,20.99
             28.00,20.99 28.00,18.99 28.00,18.99
             28.00,18.99 28.98,19.00 28.98,19.00
             28.98,19.00 28.99,17.01 28.99,17.01
             28.99,17.01 28.00,17.00 28.00,17.00
             28.00,17.00 28.00,15.00 28.00,15.00
             28.00,15.00 30.00,14.99 30.00,14.99
             30.00,14.99 30.01,16.00 30.01,16.00
             30.01,16.00 33.00,15.99 33.00,15.99
             33.00,15.99 32.99,15.00 32.99,15.00
             32.99,15.00 33.99,15.00 33.99,15.00
             33.99,15.00 34.00,13.99 34.00,13.99
             34.00,13.99 35.01,14.00 35.01,14.00
             35.01,14.00 35.01,12.00 35.01,12.00
             35.01,12.00 34.00,12.00 34.00,12.00
             34.00,12.00 34.00,11.01 34.00,11.01
             34.00,11.01 32.00,10.99 32.00,10.99
             32.00,10.99 32.00,10.00 32.00,10.00
             32.00,10.00 30.00,10.00 30.00,10.00
             30.00,10.00 29.99,11.00 29.99,11.00
             29.99,11.00 28.00,10.99 28.00,10.99
             28.00,10.99 28.00,8.99 28.00,8.99
             28.00,8.99 28.99,8.99 28.99,8.99
             28.99,8.99 28.99,7.01 28.99,7.01
             28.99,7.01 28.00,6.99 28.00,6.99
             28.00,6.99 28.00,5.02 28.00,5.02
             28.00,5.02 26.99,5.00 26.99,5.00
             26.99,5.00 26.99,4.01 26.99,4.01
             26.99,4.01 25.01,4.01 25.01,4.01
             25.01,4.01 25.00,5.00 25.00,5.00
             25.00,5.00 24.00,5.00 24.00,5.00
             24.00,5.00 24.00,6.00 24.00,6.00
             24.00,6.00 22.99,6.00 22.99,6.00
             22.99,6.00 23.00,8.99 23.00,8.99
             23.00,8.99 24.00,8.99 24.00,8.99
             24.00,8.99 24.00,10.98 24.00,10.98
             24.00,10.98 22.00,10.98 22.00,10.98
             22.00,10.98 22.00,9.99 22.00,9.99
             22.00,9.99 19.00,9.99 19.00,9.99" />
                </svg>
            </SvgIcon>


        );
    }
}

export default observer(IconeEspelhoProcesso);
